//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import PPE_BASIC_01 from './PPE_BASIC_01';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import useFileUpload from '../../../../hooks/useFileUpload';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import { showLoading } from '../../../../Reducer/LoadingReducer';
import { PPE_BASIC_01_Schema } from './PPE_BASIC_01_Schema';
import {
  useDelete1,
  useSave1,
  useSearch1,
  useSearch2,
  useSearch3,
} from './PPE_BASIC_01_QUERY';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'PPEManagement';

const toDepartmentArray = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return String(value || '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
};

const normalizePpeRows = (rows = []) =>
  rows.map((row) => {
    const useDepartmentScope = row.useDepartmentScope || 'SELECTED';
    const managerDepartments = toDepartmentArray(
      row.managerDepartments || row.managerDepartment
    );

    return {
      ...row,
      useDepartmentScope,
      managerDepartments,
      managerDepartment: managerDepartments[0] || row.managerDepartment || '',
      managerDepartmentNames:
        useDepartmentScope === 'ALL'
          ? '전체'
          : row.managerDepartmentNames || '',
      filePath: row.filePath ?? row.FilePath ?? '',
      fileName: row.fileName ?? row.FileName ?? '',
      saveName: row.saveName ?? row.SaveName ?? '',
      previewFilePath: row.previewFilePath ?? row.PreviewFilePath ?? '',
    };
  });

function PPE_BASIC_01F(props) {
  //#region 변수
  const [readyToExport, setReadyToExport] = useState(false);
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const { previewUrl, previewFileName } = useSelector(
    (state) => state.fileField
  );

  // 파일 관련 변수
  const fileInputRef = useRef(null);
  const imgRef = useRef(null); //작성자 사인
  const [excelData, setExcelData] = useState([
    {
      EquipNm: '보호구명',
      Spec: '규격',
      Price: 0,
      Unit: '단위',
      PaymentStandard: '교체주기',
      UseDepartmentScope: '사용부서범위',
      ManagerDepartment: '사용부서',
      ManagerDepartments: '사용부서목록',
      ManagerId: '담당자',
      Remark: '비고',
    },
  ]); //엑셀용 그리드 데이터

  //왼쪽 그리드
  const [rowData1, setRowData1] = useState([]); // 보호구등록 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 보호구등록 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 보호구등록 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const gridRef1 = useRef(); // 보호구등록 그리드
  const gridRef2 = useRef(); // 엑셀업로드

  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);

  // 사용부서 리스트
  const [depList, setDepList] = useState([]);
  // 담당자 리스트
  const [memberList, setMemberList] = useState([]);

  const [fileModalToggle, setFileModalToggle] = useState(false);

  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (_item, custCd) =>
      `PPEManagement/${custCd || searchInfo.custCd || ''}/PPE_BASIC_01`,
  });
  //#endregion

  useEffect(() => {
    // 현재 탭이 0번이 아닌 경우 처리하지 않음
    if (props.value !== 0) return;
    if (!props.searchClick1) return;
    ResetLogic1();

    const { custCd, depCd } = searchInfo;

    if (!custCd && !depCd) {
      props.setSearchClick1(false);
      return;
    }

    if (!props.validateSelection()) {
      props.setSearchClick1(false);
      return;
    }

    SearchLogic1();
    props.setSearchClick1(false);
  }, [props.value, props.searchClick1]);

  //#region 조회
  // 담당자 조회
  const { run: Search2 } = useSearch2({
    dateKey: 'cmBirth',
    onSuccess: (rows) => {
      const memberData = rows.map((item) => ({
        value: item.CmId || item.cmId || '',
        name: item.Ceo || item.ceo || '',
      }));
      setMemberList(memberData);
    },
  });

  // 부서 조회
  const { run: Search3 } = useSearch3({
    onSuccess: (rows) => {
      const depData = rows.map((item) => ({
        value: item.DEP_CD || item.depCd || '',
        name: item.DEP_NM_LAST || item.depNmLast || '',
      }));
      setDepList(depData);
    },
  });

  // 사업장 변경 시 사용부서, 담당자 조회
  useEffect(() => {
    if (searchInfo.custCd) {
      Search2({
        search: {
          custCd: searchInfo.custCd,
        },
      });
      Search3({
        search: {
          custCd: searchInfo.custCd,
        },
      });
    }
  }, [searchInfo.custCd]);

  // rowData1 변경 시 엑셀 데이터 업데이트 (코드값 유지)
  useEffect(() => {
    if (rowData1.length > 0) {
      // 코드값 그대로 유지 (이름으로 변환하지 않음)
      setExcelData(rowData1);
    }
  }, [rowData1]);

  // 메인 그리드 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(normalizePpeRows(rows));
    },
  });
  // 그리드 조회 함수 (기존 호환성 유지)
  const SearchLogic1 = async (_value1) => {
    ResetLogic1();
    await Search1();
  };
  //#endregion
  // QUERY: 저장/삭제 훅
  const { runAsync: Save1Async } = useSave1();
  const delete1 = useDelete1();

  // 삭제 Handler(useDeleteN)
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장(useSaveN): Schema 기반 검증 + Query 훅 실행
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '보호구명',
    schema: PPE_BASIC_01_Schema,
    getChangedRows: () => {
      const rows = changedRowData1.filter((r) => !r.deleteYn);
      return rows;
    },
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    fileSave: async (changedRows) => {
      const custCd = searchInfo.custCd;
      for (const item of changedRows) {
        if (!item.fileName && item.filePath) {
          await DeleteLogicFile(item.filePath);
        } else if (item.previewFilePath) {
          await SaveLogicFile(item, custCd);
        }
      }
    },
    fileDelete: async (deletedRows) => {
      for (const item of deletedRows) {
        if (item.filePath) {
          await DeleteLogicFile(item.filePath);
        }
      }
    },
    reset: () => {
      setChangedRowData1([]);
      setDeletedRowData1([]);
    },
    refresh: async () => {
      await SearchLogic1();
    },
  });

  // AuthButton delete 이벤트용(선택행 삭제표시)
  const DeleteLogic1 = () => {
    const newRowExists = selectedRowData1.some((row) => row.newYn === 'Y');
    if (!newRowExists) {
      deleteHandler1.MarkedForDeletion(selectedRowData1);
    } else {
      NewYnErrorMsg();
    }
  };

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async (_value1) => {
    dispatch(showLoading());
    try {
      await SearchPhoto(userInfo.sign);
      const printData = {
        FileName: 'PPE_BASIC_01',
        HeaderData: {
          CUST_NM: searchInfo.custList.filter(
            (e) => e.value === searchInfo.custCd
          )[0].name,
          USER_NM: userInfo.userNm,
          USER_SIGN: !imgRef.current
            ? ''
            : imgRef.current.replace(/^data:image\/[a-z]+;base64,/, ''),
        },
        TableData: rowData1,
      };
      Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);

      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
    }
  };
  //엑셀다운로드 버튼 클릭 시
  const ExcelDownload = async () => {
    setReadyToExport(true);
  };
  //사진 가져오기
  const SearchPhoto = async (_path) => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_path),
        }
      ).then((result) => {
        let data = result.data;
        if (data !== 'Error') {
          imgRef.current = `data:image/png;base64,${data}`;
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
    }
  };
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const NumberCommaRenderer = (params) => {
    const value = params.value;
    if (value == null || value === '') return '₩ 0';
    return `₩ ${Number(value).toLocaleString()}`; // 3자리 콤마
  };

  // 상태값 리셋
  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    setExcelData([
      {
        EquipNm: '보호구명',
        Spec: '규격',
        Price: 0,
        Unit: '단위',
        PaymentStandard: '교체주기',
        UseDepartmentScope: '사용부서범위',
        ManagerDepartment: '사용부서',
        ManagerDepartments: '사용부서목록',
        ManagerId: '담당자',
        Remark: '비고',
      },
    ]);
  };
  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1(rowData ? [rowData] : []);
  };

  const PopupFileClickEvent = async (rowData) => {
    const api = gridRef1.current?.api;
    if (api && rowData?.no != null) {
      api.deselectAll();
      api.forEachNode((node) => {
        if (node.data?.no === rowData.no) {
          node.setSelected(true, false);
        }
      });
      setSelectedRowData1([JSON.parse(JSON.stringify(rowData))]);
    }

    const newPreviewPath = rowData.previewFilePath || '';
    const existingFilePath = rowData.filePath || '';
    const name = rowData.fileName || '';
    let previewUrlVal = '';
    if (newPreviewPath) {
      const fixedPath = Commons.EncodeUrl(newPreviewPath);
      previewUrlVal = fixedPath
        ? Global.file.useUrl + 'files/' + fixedPath
        : '';
    } else if (existingFilePath) {
      const fixedPath = Commons.EncodeUrl(existingFilePath);
      previewUrlVal = fixedPath
        ? Global.file.useUrl + 'files/' + fixedPath
        : '';
    }
    dispatch(
      setFileFields({
        previewFilePathField: 'previewFilePath',
        previewFileName: name || '파일 선택',
        previewUrl: previewUrlVal,
      })
    );
    setTimeout(() => setFileModalToggle(true), 100);
  };

  const DownloadLogic1 = async () => {
    try {
      let pathVal = '';
      let nameVal = previewFileName || 'downloaded_file';

      if (previewUrl) {
        if (previewUrl.startsWith('data:')) {
          const a = document.createElement('a');
          a.href = previewUrl;
          a.download = nameVal;
          document.body.appendChild(a);
          a.click();
          a.remove();
          dispatch(
            showSnackbar({
              message: `"${nameVal}" 다운로드 완료`,
              type: 'success',
            })
          );
          return;
        }
        pathVal = previewUrl.includes(Global.file.useUrl + 'files/')
          ? decodeURIComponent(
              previewUrl.replace(Global.file.useUrl + 'files/', '')
            )
          : previewUrl;
      } else {
        const rowData = selectedRowData1?.[0];
        if (!rowData) {
          dispatch(
            showSnackbar({
              message: '파일이 존재하지 않습니다.',
              type: 'warning',
            })
          );
          return;
        }
        pathVal = rowData.previewFilePath || rowData.filePath || '';
        nameVal = rowData.fileName || nameVal;
        if (!pathVal) {
          dispatch(
            showSnackbar({
              message: '파일이 존재하지 않습니다.',
              type: 'warning',
            })
          );
          return;
        }
      }

      const finalFileName =
        nameVal === 'downloaded_file'
          ? decodeURIComponent(pathVal.split('/').pop() || nameVal)
          : nameVal;

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        { FileName: finalFileName, Url: Commons.EncodeUrl(pathVal) }
      );

      if (!result?.data || !result?.headers?.['content-type']) {
        dispatch(
          showSnackbar({
            message: `"${finalFileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([result.data], {
        type: result.headers['content-type'],
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${finalFileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };
  //#endregion

  return (
    <PPE_BASIC_01
      value={props.value}
      userInfo={userInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      setDeletedRowData1={setDeletedRowData1}
      filterClick1={props.filterClick1}
      setFilterClick1={props.setFilterClick1}
      searchClick1={props.searchClick1}
      setSearchClick1={props.setSearchClick1}
      addClick1={props.addClick1}
      setAddClick1={props.setAddClick1}
      saveClick1={props.saveClick1}
      setSaveClick1={props.setSaveClick1}
      deleteClick1={props.deleteClick1}
      setDeleteClick1={props.setDeleteClick1}
      printClick1={props.printClick1}
      setPrintClick1={props.setPrintClick1}
      listClick1={props.listClick1}
      setListClick1={props.setListClick1}
      dateValue1={props.dateValue1}
      setDateValue1={props.setDateValue1}
      dateValue2={props.dateValue2}
      setDateValue2={props.setDateValue2}
      searchSiteCd={props.searchSiteCd}
      excelData={excelData}
      setExcelData={setExcelData}
      readyToExport={readyToExport}
      setReadyToExport={setReadyToExport}
      fileInputRef={fileInputRef}
      gridRef1={gridRef1}
      gridRef2={gridRef2}
      selectedRowNosRef={selectedRowNosRef}
      lastCheckedIndexRef={lastCheckedIndexRef}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      SaveLogic1={Save1}
      DeleteLogic1={DeleteLogic1}
      PrintLogic1={PrintLogic1}
      ExcelDownload={ExcelDownload}
      SearchPhoto={SearchPhoto}
      handleRowSelection={handleRowSelection}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      RestoreRow1={deleteHandler1.RestoreRow}
      NewYnErrorMsg={NewYnErrorMsg}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
      NumberCommaRenderer={NumberCommaRenderer}
      depList={depList}
      memberList={memberList}
      fileModalToggle={fileModalToggle}
      setFileModalToggle={setFileModalToggle}
      PopupFileClickEvent={PopupFileClickEvent}
      SaveLogicPreview={SaveLogicPreview}
      DownloadLogic1={DownloadLogic1}
    />
  );
}

export default PPE_BASIC_01F;
